<template>
    <div>
          <div class="innerSearch">
                <div class="box">
                     <input ref="keyword" class="search-input" type="text" placeholder="请输入关键词">
                    <a href="javascript:void(0)" @click="ClickSearch()">搜索</a>
                </div>
            </div>
           <div class="cmfLibraryList">
                <div class="crumbCurr clearfix">
					   <span class="tip">所有分类></span>
					   <div class="curr-tag">
					       <template v-for="item in tags_data.lingyu">
					           <a :key="'tag_lingyu_'+item.id" @click="CancelTag(item)">
					               {{item.title}}：{{item.value}}
								   <img src="../../assets/images/icon_3.png">
					               <!-- <span class="icon-close"></span> -->
					           </a>
					       </template>
					       <template v-for="item in tags_data.caizhi">
					           <a :key="'tag_caizhi_'+item.id" @click="CancelTag(item)">
					               {{item.title}}：{{item.value}}
					               <img src="../../assets/images/icon_3.png">
					           </a>
					       </template>
					       <template v-for="item in tags_data.craft">
					           <a :key="'tag_craft_'+item.id" @click="CancelTag(item)">
					               {{item.title}}：{{item.value}}
					               <img src="../../assets/images/icon_3.png">
					           </a>
					       </template>
					       <template v-for="item in tags_data.gongneng">
					           <a :key="'tag_gongneng_'+item.id" @click="CancelTag(item)">
					               {{item.title}}：{{item.value}}
					               <img src="../../assets/images/icon_3.png">
					           </a>
					       </template>
					       <template v-for="item in tags_data.sort">
					           <a :key="'tag_sort_'+item.id" @click="CancelTag(item)">
					               {{item.title}}：{{item.value}}
					               <img src="../../assets/images/icon_3.png">
					           </a>
					       </template>
					   </div>
				   </div>
                   <div class="cmfTypeSelect">
				       <div class="selectlist clearfix">
				           <ul>
				               <li>
				                   <CmfDropdownCom title="领域" ref='filter_lingyu' v-model="selected_lingyu" :options="list_lingyu" @valueChange="FilterChange"></CmfDropdownCom>
				               </li>
				               <li>
				                   <CmfDropdownCom title="材质" ref='filter_caizhi' v-model="selected_caizhi" :options="list_caizhi" @valueChange="FilterChange"></CmfDropdownCom>
				               </li>
				               <li>
				                   <CmfMutiDropdownCom title="工艺" ref='filter_craft' v-model="selected_craft" :options="list_craft" @valueChange="FilterChange"></CmfMutiDropdownCom>
				               </li>
				               <li>
				                   <CmfMutiDropdownCom title="功能" ref='filter_gongneng' :is_single="true" v-model="selected_gongneng" :options="list_gongneng" @valueChange="FilterChange"></CmfMutiDropdownCom>
				               </li>
				               <li>
				                   <CmfDropdownCom title="排序" ref='filter_sort' v-model="selected_sort" :options="list_sort" @valueChange="FilterChange"></CmfDropdownCom>
				               </li>
				           </ul>
				       </div>
				   </div>
				   
            </div>

             <template v-if="total==0">
                    <div class="nodataTip">
                        <div class="ico">
                            <img src="../../assets/images/nodataTip.png" alt="">
                        </div>
                        <div class="text">暂无数据~</div>
                    </div>
                </template>

             <div class="wall clearfix" :key="k">
                <template v-for="(item) in list">
                    <div class="article" :key="'material_'+item.id">
                        <a :href="'javascript:this.ViewMaterialDetail('+item.id+')'">
                            <div class="img">
                                <img :src="utils.HandleImg(item.img_url,false,1)" alt="">
                            </div>
                            <div class="info">
                                <p class="title">{{item.title}}</p>
                                <p class="pull">
                                    <span class="read">{{item.click}}</span>
                                </p>
                            </div>
                        </a>
                    </div>
                </template>
            </div>
    </div>
</template>
<script>
import CmfDropdownCom from '../../components/Common/CmfDropdownCom'
import CmfMutiDropdownCom from '../../components/Common/CmfMutiDropdownCom'
// import {Input} from 'element-ui';
// import { Toast } from "vant";
import $ from 'jquery'
require('../../../static/js/jaliswall');
import EventBus from '../../utils/eventbus'
export default {
  data(){
    return{
        list:[],
        keyword:'',
        pageindex:0,
        pagesize:30,
        total:0,
        loading:false,
        isend:false,
        scroll_fun:null,
        k:1,
        selected_m_type:0,
        list_lingyu:[],
        selected_lingyu:0,
        list_caizhi:[],
        selected_caizhi:0,
        list_craft:[],
        selected_craft:'',
        list_gongneng:[],
        selected_gongneng:'',
        list_sort:[{title:'排序',id:0},{title:'最新发布',id:3},{title:'查看最多',id:1}],
        selected_sort:0,
        tags_data:{
            lingyu:[],
            caizhi:[],
            craft:[],
            gongneng:[],
            sort:[]
        }
    }
  },
  created(){
        var lingyu_id=this.$route.query.lingyu;
        if (lingyu_id>0){
            this.selected_lingyu=lingyu_id;
        }
        this.GetItems(4,'lingyu');
        this.GetItems(6,'caizhi');
        this.GetItems(5,'craft');
        this.GetItems(2,'gongneng');
    if (this.set_pagesize>0){
            this.pagesize=this.set_pagesize;
        }
        this.scroll_fun = this.utils.AddLoadMoreListener(this.GetList,400);
        window.ViewMaterialDetail=this.ViewDetail;
  },
  mounted:function(){
        this.GetList();
    },
  components:{
    // [Input.name]:Input,
    CmfDropdownCom,
    CmfMutiDropdownCom,
  },
  methods:{
     GetItems(_type, _name) {
            var url = "http://api.xincailiao.com/Open/GetFilterTags";
            this.$http.post(url,{type: _type}).then(function(res){
                if (res.data.status==1){
                    if (_type==5||_type==2){
                        this['list_'+_name] = res.data.ds;
                    }else{
                        res.data.ds.unshift({id:0,title:'全部'});
                        this['list_'+_name] = res.data.ds;
                    }
                }
            }.bind(this)).catch(function(){
            });
        },
        FilterChange(_data){
            var type='';
            if (_data.title=='领域') type='lingyu';
            else if (_data.title=='材质') type='caizhi';
            else if (_data.title=='工艺') type='craft';
            else if (_data.title=='功能') type='gongneng';
            else if (_data.title=='排序') type='sort';
            if (this.tags_data[type]!=undefined){
                this.tags_data[type]=_data.list_value;
            }
        },
         CancelTag(_item){
            this.$refs.filter_lingyu.CancelTag(_item);
            this.$refs.filter_caizhi.CancelTag(_item);
            this.$refs.filter_craft.CancelTag(_item);
            this.$refs.filter_gongneng.CancelTag(_item);
            this.$refs.filter_sort.CancelTag(_item);
        },
    GetList(){
           if (this.loading||this.isend) return;
           this.pageindex++;
           this.loading=true;
            var url="http://api.xincailiao.com/Open/GetMaterialList";
            this.$http.post(url,{pageindex:this.pageindex,pagesize:this.pagesize,keyword:this.keyword,lingyu_id:this.selected_lingyu,caizhi_id:this.selected_caizhi,sort_type:this.selected_sort,craft_ids:this.selected_craft,gongneng_ids:this.selected_gongneng
            }).then(function(res){
                if (res.data.status==1){
                    this.list=this.list.concat(res.data.ds);
                    this.total=res.data.total;
					this.InitWaterfall();
					this.$emit('input', res.data.total);
					if (this.pageindex*this.pagesize>=res.data.total){
					    this.isend=true;
					}
                }
                //延时，以免一直加载
                setTimeout(()=>{
                    this.loading=false;
                },1000);
            }.bind(this)).catch(function(){
            });
        },
         ViewDetail(_id){
            EventBus.$emit("pop_material",_id);
        },
        PropsChange(){
            this.pageindex=0;
            this.list=[];
            this.k++;
            this.loading=false;
            this.isend=false;
            this.GetList();
        },
        ClickSearch: function () {
            this.keyword = $(this.$refs.keyword).val();
        },
        InitWaterfall(){
            this.$nextTick(function(){
                $('.wall').jaliswall({
                    item: '.article'
                });
            });
        },
    },
    watch:{
        keyword(){
            this.PropsChange();
        },
         selected_lingyu(){
            this.PropsChange();
        },
        selected_caizhi(){
            this.PropsChange();
        },
        selected_sort(){
            this.PropsChange();
        },
        selected_craft(){
            this.PropsChange();
        },
        selected_gongneng(){
            this.PropsChange();
        }
       
    },
    destroyed(){
        window.removeEventListener('scroll',this.scroll_fun)
    },
}
</script>
